<style lang="scss">
.choose-subject {
  margin-top: 19px;
  padding: 10px 0;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.2);
  @media (min-width: 992px) {
    padding: 30px 50px;
  }
  @media (min-width: 1200px) {
    padding: 30px 70px;
  }
  .content {
    width: 572px;
    margin: 44px auto;
    @media screen and (max-width: 768px) {
      margin: 20px auto;
      width: 90%;
    }
  }
  .compulsory-group {
    margin: 20px 0 60px -20px;
  }
  .optional-group {
    margin: 20px 0 0 -20px;
  }
  .steps {
    margin: 44px auto;
    width: 280px;
  }
  .line {
    border-top: 3px solid #cccccc;
    width: 30px;
    margin: 8px 18px;
  }
  .title {
    padding-left: 20px;
    background-position: 2px 1px;
  }
  .subject {
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 3px;
    float: left;
    padding: 7px 22px;
    color: #cccccc;
    margin-left: 20px;
    line-height: 16px;
    margin-top: 20px;
    text-align: center;
    width: 170px;
    background-position: calc(100% + 1px) calc(100% + 1px);
    .subject-name {
      height: 40px;
      vertical-align: middle;
      text-align: center;
      width: 126px;
      display: table-cell;
    }
  }
  .btn-box {
    text-align: center;
  }
  .optional-subject {
    cursor: pointer;
  }
  .type-list {
    margin-top: 10px;
  }
  .long-line {
    border-top: 1px dashed #cccccc;
    margin: 30px 0;
  }
  .level {
    display: inline-block;
    width: 100px;
  }
  .tip-box {
    margin: 20px 0;
  }
}
</style>
<template>
  <div>
    <div class="choose-subject">
      <exam-reg-menu menuIndex="3"></exam-reg-menu>
      <div class="steps">
        <div class="float-left AEE-tc">① 科目选择</div>
        <div class="float-left line"></div>
        <div class="float-left">② 考区选择</div>
      </div>
      <div class="clear"></div>
      <div class="tip-box" v-html="tip"></div>
      <!--没有科目类别-->
      <div class="content" v-if="!haveType">
        <div class="title AEE-tc subject-bot" v-if="compulsory_group.length>0">
          <span v-if="!showPrice">必考科目</span>
          <span v-else>笔试科目</span>
        </div>
        <div class="compulsory-group" v-if="compulsory_group.length>0">
          <div class="subject AEE-tc AEE-bc chosed-subject" v-for="item in compulsory_group">
            <div class="subject-name">{{item.subject_name}}</div>
            <div
              style="font-size: 10px"
              v-if="pay_switch_status&&!showPrice"
            >金额：{{item.price.toFixed(2)}}</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="title AEE-tc subject-bot" v-if="optional_group.length>0">
          <span v-if="!showPrice">选考科目</span>
          <span v-else>现场考试</span>
        </div>
        <div class="optional-group" v-if="optional_group.length>0">
          <div
            class="subject optional-subject"
            v-for="item in optional_group"
            @click="chooseSubject($event,item)"
            :class="{'AEE-tc AEE-bc chosed-subject':beSelected(item)}"
          >
            <div class="subject-name">{{item.subject_name}}</div>
            <div
              style="font-size: 10px"
              v-if="pay_switch_status&&!showPrice"
            >金额：{{item.price.toFixed(2)}}</div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!--有科目类别-->
      <div class="content" v-else>
        <div v-for="type_level,index in subject_types" :key="index" class="type-list">
          <div class="level">{{subject_type_levels[index].name}}：</div>
          <el-radio-group v-model="choose_type[index]">
            <el-radio
              v-for="type in type_level"
              :label="type.id"
              :key="type.id"
              @change="chooseType(index,type)"
            >{{type.name}}</el-radio>
          </el-radio-group>
        </div>
        <div class="p-group" v-if="subject_show">
          <!--科目类别1必选，2可选-->
          <div
            class="subject optional-subject"
            v-for="item in subject_group"
            @click="item.type==2?chooseSubject($event,item):1"
            :class="{'AEE-tc AEE-bc chosed-subject':beSelected(item)}"
          >
            <div class="subject-name">{{item.subject_name}}</div>
            <div style="font-size: 10px" v-if="pay_switch_status">金额：{{item.price.toFixed(2)}}</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="long-line"></div>
        <div v-if="choose_subject.length>0">
          <div class="float-left level">已选：</div>
          <div v-if="choose_subject.length>0" class="float-left">
            <div
              v-for="item in choose_subject"
              @click="item.type==2?chooseSubject($event,item):1"
              class="subject AEE-tc AEE-bc optional-subject chosed-subject"
            >
              <div class="subject-name">{{item.subject_name}}</div>
              <div style="font-size: 10px" v-if="pay_switch_status">金额：{{item.price.toFixed(2)}}</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="btn-box">
        <el-button class="btn-agree" @click="preStep()" type="primary">上一步</el-button>
        <el-button class="btn-agree" @click="nextStep()" type="primary" :disabled="btnDisable">下一步</el-button>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import m1_examRegMenu from "@components/examRegMenu/m1_examRegMenu";
export default {
  components: {
    examRegMenu: m1_examRegMenu
  },
  data() {
    return {
      showPrice: false,
      domain: this.$store.state.examInfo.currentExamInfo.domain,
      tip: "",
      compulsory_group: [],
      optional_group: [],
      subject_group: [],
      choose_subject: [],
      choose_subject_ids: [],
      choose_type: [],
      subject_show: false,
      field: {},
      btnDisable: false,
      haveType: false,
      subject_types: [],
      subject_type_levels: [],
      pay_switch_status: ""
    };
  },
  methods: {
    getData: function() {
      this.pay_switch_status = this.$store.state.examRegInfo.examRegInfo.pay_switch_status;
      this.$http.get(globalProvider.serviceUrl("e_reg/q/st")).then(data => {
        if (data.body.code === resultCode.Success) {
          this.FirstGetSubject();
          if (data.body.data && data.body.data.subject_types.length > 0) {
            this.haveType = true;
            this.subject_types = [];
            this.subject_types[0] = data.body.data.subject_types;
            this.subject_type_levels = data.body.data.subject_type_levels;
          }
        }
      });
    },
    //获取页面提示信息
    getTip: function() {
      this.$http
        .get(globalProvider.serviceUrl("e_reg/g/sts/{key_code}"), {
          params: { key_code: tipKeyCode.subject_reg_success }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            if (data.body.data != null) {
              this.tip = data.body.data.key_value;
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message));
          }
        });
    },
    FirstGetSubject() {
      this.$http
        .get(globalProvider.serviceUrl("e_reg/g/subsbr/{reg_id}"), {
          params: {
            region_id: this.$store.state.examRegInfo.examRegInfo
              .region_subject_selections.region_id,
            reg_id: this.$store.state.examRegInfo.examRegInfo
              .exam_registration_id
          }
        })
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.rule = data.body.data.subject_rules;
            this.compulsory_group =
              data.body.data.subject_data.compulsory_group;
            this.optional_group = data.body.data.subject_data.optional_group;
            this.field = this.$store.state.examRegInfo.examRegInfo.region_subject_selections;
            for (let i in this.compulsory_group) {
              this.choose_subject.push(this.compulsory_group[i]);
              this.choose_subject_ids.push(this.compulsory_group[i].subject_id);
            }
            if (this.field.subjects) {
              for (let i in this.field.subjects) {
                for (let j in this.optional_group) {
                  if (
                    this.optional_group[j].subject_id ==
                    this.field.subjects[i].subject_id
                  ) {
                    this.choose_subject.push(this.optional_group[j]);
                    this.choose_subject_ids.push(
                      this.optional_group[j].subject_id
                    );
                  }
                }
              }
            }
          }
        });
    },
    chooseType(index, type) {
      this.subject_show = false;
      if (index < this.choose_type.length) {
        this.subject_types.splice(index + 1, 10);
        this.choose_type.splice(index, 10);
      }
      this.choose_type[index] = type.id;
      //判断类别是否有下级
      if (typeof type.children != "object") {
        this.subject_show = true;
        this.getSubject();
      } else {
        this.subject_types[index + 1] = type.children;
      }
    },
    getSubject() {
      this.$http
        .get(
          globalProvider.serviceUrl(
            "e_reg/g/subsbr/{reg_id}/{subject_type_ids}"
          ),
          {
            params: {
              region_id: this.$store.state.examRegInfo.examRegInfo
                .region_subject_selections.region_id,
              reg_id: this.$store.state.examRegInfo.examRegInfo
                .exam_registration_id,
              subject_type_ids: this.choose_type.join(",")
            }
          }
        )
        .then(data => {
          if (data.body.code === resultCode.Success) {
            this.subject_group = data.body.data.subject_data.compulsory_group.concat(
              data.body.data.subject_data.optional_group
            );
          }
        });
    },
    chooseSubject: function(e, item) {
      if (this.choose_subject_ids.indexOf(item.subject_id) != -1) {
        this.choose_subject.splice(
          this.choose_subject_ids.indexOf(item.subject_id),
          1
        );
        this.choose_subject_ids.splice(
          this.choose_subject_ids.indexOf(item.subject_id),
          1
        );
      } else {
        if (this.rule[item.subject_id]) {
          if (this.rule[item.subject_id].length > 0) {
            let list = [];
            this.choose_subject.forEach(n => {
              for (let i in this.rule[item.subject_id]) {
                if (n.subject_id == this.rule[item.subject_id][i]) {
                  list.push(this.choose_subject.indexOf(n));
                }
              }
            });
            list.reverse();
            for (let item in list) {
              this.choose_subject.splice(list[item], 1);
              this.choose_subject_ids.splice(list[item], 1);
            }
          }
        }
        this.choose_subject.push(item);
        this.choose_subject_ids.push(item.subject_id);
      }
    },
    beSelected: function(item) {
      if (this.choose_subject_ids.indexOf(item.subject_id) != -1) {
        return true;
      } else {
        return false;
      }
    },
    preStep: function() {
      this.$store.commit("setBackOrNextStep", "back");
      let RegInfoModel = this.$store.state.examRegInfo.examRegInfo;
      if (RegInfoModel.file_info_confs.length > 0) {
        this.$router.push({ name: "default.examReg.fileCollection" });
      } else if (RegInfoModel.pic_info_confs.length > 0) {
        this.$router.push({ name: "default.examReg.imgCollection" });
      } else if (RegInfoModel.text_info_confs.length > 0) {
        this.$router.push({ name: "default.examReg.baseCollection" });
      } else {
        this.$router.push({ name: "default.examReg.examNotes" });
      }
    },
    nextStep: function() {
      this.btnDisable = true;
      let examRegInfo = this.$store.state.examRegInfo.examRegInfo;
      if (this.choose_subject.length > 0) {
        this.field.subjects = this.choose_subject;
        let subject_regions = this.choose_subject.map(item => {
          return { subject_id: item.subject_id };
        });
        this.$http
          .post(globalProvider.serviceUrl("e_reg/v/ers"), {
            eri: examRegInfo.exam_registration_id,
            subject_regions
          })
          .then(data => {
            this.btnDisable = false;
            if (data.body.code === resultCode.Success) {
              this.$store.commit("setExamRegInfoItem", {
                region_subject_selections: this.field
              });
              this.$router.push({ name: "default.examReg.chooseExamRegion2" });
            } else if (data.body.code == resultCode.NotSuccess) {
              if (data.body.message == "E_REG_SUI_SSRS_04") {
                 this.$alert(`请选择${data.body.data}门科目进行报考`, { confirmButtonText: "确定" });
              } else {
                this.$alert(getErrorMessage(data.body.message));
              }
            }
          });
      } else {
        this.btnDisable = false;
        this.$alert("请选择至少一个科目", { confirmButtonText: "确定" });
      }
      // this.btnDisable = true;
      // if (this.choose_subject.length > 0) {
      //     this.field.subjects = this.choose_subject;
      //     this.$store.commit('setExamRegInfoItem', {region_subject_selections: this.field});
      //     this.$router.push({name: 'default.examReg.chooseExamRegion2'});
      // } else {
      //     this.btnDisable = false;
      //     this.$alert("请选择至少一个科目", {confirmButtonText: "确定"});
      // }
    },
    isShowPrice() {
      this.showPrice = globalProvider.isGuideDomain(this.domain);
    }
  },
  created: function() {
    this.$store.commit("setHeaderState", "3");
    this.getData();
    this.getTip();
    this.isShowPrice();
  }
};
</script>